<form (ngSubmit)="onSubmit()" class="form" [formGroup]="filtersForm">
  <br/>
  <app-input name="searchInputText"
             [formControl]="filtersForm.controls['searchInputText']"
             [parentFormGroup]="filtersForm"
             inputId="input-search-location"
             [isFullWidth]="true"
             [placeholder]="placeholder || ('searchBar.nearMePlaceHolder' | translate)">
    <svg height="18" width="18" xmlns="http://www.w3.org/2000/svg" aria-label="Search" class="has-pos-abs">
      <image x="0" y="0" height="18" width="18" attr.xlink:href="{{'/assets/icons/filters/Search_icon@1x.svg' | staticp }}" />
    </svg>
    <b translate="filters.search"></b>

  </app-input>

  <hr/>

  <app-select [label]="('filters.office.real-estate-type' | translate)"
              [options]="realEstateTypeOptions"
              [placeholder]="'filters.search-filters.any-real-estate-type' | translate"
              [formControl]="filtersForm.get('realEstateType')"
              [parentFormGroup]="filtersForm">
  </app-select>

  <hr/>

  <app-select [label]="('filters.office.language' | translate)"
              [options]="languageOptions"
              [placeholder]="'filters.search-filters.any-language' | translate"
              [formControl]="filtersForm.get('language')"
              [parentFormGroup]="filtersForm">
  </app-select>

  <hr/>

  <app-select [label]="('filters.office.specialty' | translate)"
              [options]="specialtyOptions"
              [placeholder]="'filters.search-filters.any-specialty' | translate"
              [formControl]="filtersForm.get('specialty')"
              [parentFormGroup]="filtersForm">
  </app-select>

  <hr/>

  <p>
    <b translate="filters.office.proud-supporter"></b>
  </p>
  <fieldset [formGroup]="filtersForm">
    <app-checkbox [text]="'filters.office.childrens-miracle-network' | translate"
                  [formControl]="filtersForm.get('childrensMiracleNetwork')"
                  [parentFormGroup]="filtersForm">
    </app-checkbox>
  </fieldset>

  <hr/>

  <!-- <p>
    <b translate="filters.office.additional-keywords"></b>
  </p>
  <div>
    Coming soon
  </div>
  <app-input [name]="'searchMoreFeatures'"
             [formControl]="filtersForm.get('searchMoreFeatures')"
             [parentFormGroup]="filtersForm"
             inputId="input-search-more-features"
             [isFullWidth]="true"
             [placeholder]="placeholder || ('filters.office.search-more-features' | translate)">
    <svg height="18" width="18" xmlns="http://www.w3.org/2000/svg" aria-label="Search" class="has-pos-abs">
      <image x="0" y="0" height="18" width="18" attr.xlink:href="{{'/assets/icons/filters/Search_icon@1x.svg' | staticp }}" />
    </svg>
  </app-input> -->
</form>
